<template>
  <b-row class="mx-0 margin-bottom-22">
    <b-col v-if="title" cols="12" md="12" class="px-0">
      <div class="font-size-12 color-complementary-300 margin-bottom-8">
        {{ title }}
      </div>
    </b-col>
    <b-col cols="12" md="12" class="position-relative px-0 input">
      <div class="position-relative">
        <span v-if="rightIcon" class="input__right-icon">
          <mdicon :name="rightIcon" size="24" />
        </span>
        <span
          v-if="hasEraseIcon && date && !disabled"
          class="input__erase-icon"
          @click="erase"
        >
          <mdicon name="close" size="24" />
        </span>
        <b-form-input
          v-model="inputModel"
          type="text"
          :placeholder="placeholder"
          :id="id"
          :autocomplete="autocomplete"
          :disabled="disabled"
          :state="generateState"
          :aria-describedby="`${id}-help ${id}-feedback`"
          trim
          :class="`custom-input-${id} 
          ${rightIcon ? 'right-icon' : ''} 
          ${hasEraseIcon ? 'erase-icon' : ''}`"
          @focus="focus"
          @blur="blur"
        />
        <date-picker
          v-model="date"
          :type="type"
          :format="format"
          :display-format="displayFormat"
          :custom-input="`.custom-input-${id}`"
          :popover="popover"
          :simple="simple"
          :auto-submit="autoSubmit"
          :max="max"
        />
      </div>
    </b-col>
    <b-col cols="12" md="12" class="px-0">
      <FeedbackMessages
        :state="generateState"
        :label="label"
        :vuelidateObj="vuelidateObj"
      />
    </b-col>
  </b-row>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import FeedbackMessages from "../feedback-messages/FeedbackMessages.vue";
import { includes } from "ramda";

export default {
  components: {
    FeedbackMessages,
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    value: null,
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "عنوان",
    },
    id: {
      type: String,
      default: "default-id",
    },
    type: {
      type: String,
      default: "date",
    },
    placeholder: {
      type: String,
      default: "",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    vuelidateObj: {
      type: Object,
      default: null,
    },
    popover: {
      type: Boolean,
      default: false,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    autoSubmit: {
      type: Boolean,
      default: false,
    },
    displayFormat: {
      type: String,
      default: "jYYYY/jMM/jDD",
    },
    format: {
      type: String,
      default: "YYYY-MM-DD",
    },
    max: {
      type: String,
      default: null,
    },
    rightIcon: {
      type: String,
      default: null,
    },
    hasEraseIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: null,
      inputModel: null,
    };
  },
  computed: {
    generateState() {
      return this.vuelidateObj.$dirty ? !this.vuelidateObj.$error : null;
    },
  },
  watch: {
    date(val) {
      this.$emit("input", this.name, val);
    },
  },
  mounted() {
    this.date = this.value;
  },
  methods: {
    includes,
    blur() {
      this.$emit("blur", this.name, this.date);
    },
    focus() {
      this.$emit("focus", this.name);
    },
    erase() {
      this.date = null;
      this.inputModel = null;
      this.$emit("erase", this.name, null);
    },
  },
};
</script>
